import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import clsx from 'clsx';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helper?: string;
  error?: string;
  leading?: ReactNode;
  trailing?: ReactNode;
  mono?: boolean;
}

export const TextField = forwardRef<HTMLInputElement, Props>(function TextField(
  { label, helper, error, leading, trailing, mono, className, id, ...rest },
  ref,
) {
  const inputId = id ?? rest.name;
  return (
    <label htmlFor={inputId} className="block">
      {label ? (
        <span className="pb-eyebrow mb-1.5 block">{label}</span>
      ) : null}
      <span className="relative block">
        {leading ? (
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-tg-hint">
            {leading}
          </span>
        ) : null}
        <input
          id={inputId}
          ref={ref}
          className={clsx(
            'pb-input',
            leading && 'pl-10',
            trailing && 'pr-12',
            mono && 'font-mono',
            error && 'border-pb-danger focus:border-pb-danger focus:shadow-none',
            className,
          )}
          {...rest}
        />
        {trailing ? (
          <span className="absolute right-2 top-1/2 -translate-y-1/2">
            {trailing}
          </span>
        ) : null}
      </span>
      {error ? (
        <span className="mt-1.5 block text-xs text-pb-danger">{error}</span>
      ) : helper ? (
        <span className="pb-caption mt-1.5 block">{helper}</span>
      ) : null}
    </label>
  );
});
